





































import { Vue, Component, Watch } from "vue-property-decorator";
import { ActShort as IAct } from "@/api/models/act-short";
import { BillShort as IBill } from "@/api/models/bill-short";
import bills, { BillListParams } from "@/getinfo-api/bills";
import acts from "@/getinfo-api/acts";
import {
  getCurrentCompanyId,
  isRoot,
  currentUserIsCompanyOwner,
  getCurrentEmployee
} from "@/plugins/roles";
import MoneyBlockItemStatistic from "@/components/home-page/MoneyBlockItemStatistic.vue";
import CustomDatepicker from "@/components/form/CustomDatepicker.vue";
import CustomButton from "@/components/form/CustomButton.vue";

@Component({
  components: { CustomButton, CustomDatepicker, MoneyBlockItemStatistic }
})
export default class MoneyBlock extends Vue {
  acts: Array<IAct> = [];
  bills: Array<IBill> = [];
  actsByDate: Array<IAct> = [];
  billsByDate: Array<IBill> = [];
  isGetEntities: boolean = false;
  actParams = {
    count: 0,
    offset: 0,
    limit: 50
  };
  billParams = {
    count: 0,
    offset: 0,
    limit: 50
  };

  startedAt: Date = new Date(
    new Date().getFullYear(),
    new Date().getMonth(),
    1
  );
  finishedAt: Date = new Date();

  get employee() {
    return getCurrentEmployee();
  }

  get root() {
    return isRoot();
  }

  get companyOwner() {
    return currentUserIsCompanyOwner();
  }

  get companyId() {
    return getCurrentCompanyId();
  }

  // price - общая стоимость, amount - computed
  get allBillsPrice() {
    return this.sortedByPrice(this.bills);
  }

  get allBillsPayment() {
    return this.sortedBillsPayments(this.bills);
  }

  get allActsSignedPrice() {
    return this.sortedActsSignedPrice(this.acts, true);
  }

  get allActsNotSignedPrice() {
    return this.sortedActsSignedPrice(this.acts, false);
  }

  get billsOnStartedMonth() {
    return this.sortedStartedMonth(this.bills);
  }

  get actsOnStartedMonth() {
    return this.sortedStartedMonth(this.acts);
  }

  get monthBillsPrice() {
    return this.sortedByPrice(this.billsOnStartedMonth);
  }

  get monthBillPayment() {
    return this.sortedBillsPayments(this.billsOnStartedMonth);
  }

  get monthActsSignedPrice() {
    return this.sortedActsSignedPrice(this.actsOnStartedMonth, true);
  }

  get monthActsNotSignedPrice() {
    return this.sortedActsSignedPrice(this.actsOnStartedMonth, false);
  }

  async getEntitiesByDate() {
    this.actParams.count = 0;
    this.actParams.limit = 50;
    this.actParams.offset = 0;
    this.billParams.count = 0;
    this.billParams.limit = 50;
    this.billParams.offset = 0;
    this.billsByDate = [];
    this.actsByDate = [];
    this.isGetEntities = true;
    await Promise.allSettled([this.getActsByDate(), this.getBillsByDate()]);
    this.isGetEntities = false;
  }

  async getActsByDate() {
    let params: BillListParams = {
      companyId: this.companyId,
      formedAtMax: this.finishedAt ? this.finishedAt : undefined,
      formedAtMin: this.startedAt ? this.startedAt : undefined,
      responsibleId:
        this.root || this.companyOwner ? undefined : this.employee.id,
      offset: this.actParams.offset,
      limit: this.actParams.limit
    };

    try {
      let { data } = await acts(params);
      this.actParams.count = data.count;
      this.actsByDate = [...this.actsByDate, ...data.items];
      if (this.actsByDate.length < this.actParams.count) {
        this.actParams.offset += this.actParams.limit;
        await this.getActsByDate();
      }
    } catch (err) {
      await this.$store.dispatch("errorException", {
        vm: this,
        //@ts-ignore
        error: err.response
      });
    }
  }

  async getBillsByDate() {
    let params: BillListParams = {
      companyId: this.companyId,
      formedAtMax: this.finishedAt ? this.finishedAt : undefined,
      formedAtMin: this.startedAt ? this.startedAt : undefined,
      responsibleId:
        this.root || this.companyOwner ? undefined : this.employee.id,
      offset: this.billParams.offset,
      limit: this.billParams.limit
    };

    try {
      let { data } = await bills(params);
      this.billParams.count = data.count;
      this.billsByDate = [...this.billsByDate, ...data.items];
      if (this.billsByDate.length < this.billParams.count) {
        this.billParams.offset += this.billParams.limit;
        await this.getBillsByDate();
      }
    } catch (err) {
      await this.$store.dispatch("errorException", {
        vm: this,
        //@ts-ignore
        error: err.response
      });
    }
  }

  created() {
    this.getEntitiesByDate();
  }

  sortedByPrice(items: Array<IBill | IAct>) {
    let sorted = items?.map(el => {
      return el.price;
    });
    return sorted.length ? sorted.reduce((a, b) => a + b, 0) : 0;
  }

  sortedStartedMonth<T extends IBill | IAct>(items: Array<T>): T[] {
    let date = new Date(),
      y = date.getFullYear(),
      m = date.getMonth();
    let firstDayTimestamp = new Date(y, m, 1);

    let sorted = items?.filter(
      el => new Date(el.createdAt).getTime() > firstDayTimestamp.getTime()
    );

    return sorted?.length ? sorted : [];
  }

  sortedActsSignedPrice(items: Array<IAct>, signed: boolean) {
    let allSignedActs = items
      ?.filter(el => (signed ? el.signedAt : !el.signedAt))
      ?.map(el => el.price);

    return allSignedActs.length ? allSignedActs.reduce((a, b) => a + b, 0) : 0;
  }

  sortedBillsPayments(items: Array<IBill>) {
    let billsPayments = items?.map(el => {
      return el.payments?.map(payment => payment.amount);
    });

    return billsPayments.length
      ? billsPayments?.flat().reduce((a, b) => a! + b!, 0)
      : 0;
  }

  @Watch("companyId")
  upd() {
    this.finishedAt = new Date();
    this.startedAt = new Date(
      new Date().getFullYear(),
      new Date().getMonth(),
      1
    );
    this.getEntitiesByDate();
  }
}
